<template>
  <div class="send-flower">
    <img
      class="toast-bg"
      src="https://btw-common-data.betterwestar.com/btw-admin/resource/b30bf287f0ecd9587180b3370a972c36_wh=1125_870.png"
      alt=""
    />
    <img
      class="title-image"
      src="https://btw-common-data.betterwestar.com/btw-admin/resource/584dae8446493d6b15e849dc86a5b6d6_wh=471_192.png"
      alt=""
    />
    <div class="close" @click="bindClose"
      ><span class="iconfont icon-cha"></span
    ></div>
    <div class="tips">选择近一年约过课的教练，送朵小红花鼓励一下吧！</div>
    <div class="coach-container">
      <div class="coach-scroll">
        <div class="coach-list" v-if="myCoachList">
          <div
            class="coach-item"
            v-for="(item, index) in myCoachList"
            :key="index"
          >
            <div class="avatar-container">
              <img class="avatar" :src="item.coach_img" alt="" />
              <div class="main" v-if="item.is_head_coach">主教练</div>
            </div>
            <div class="item-center">
              <div class="item-truename">{{ item.coach_name }}</div>
              <div class="item-store">{{ item.coach_store_name }}</div>
            </div>
            <img
              class="send-flower-btn"
              @click="bindSendFlower(item)"
              src="https://btw-common-data.betterwestar.com/btw-admin/resource/e8e930eec95cff64838005bd6ff92cb7_wh=297_117.png"
              alt=""
            />
          </div>
          <div class="empty" v-if="!myCoachList.length">
            <img
              class="empty-image"
              src="https://btw-common-data.betterwestar.com/btw-admin/resource/c6909e87377d090f266d8b1e7f1852c5_wh=642_339.png"
              alt=""
            />
            <div class="empty-text">暂无约过课的教练</div>
          </div>
        </div>
        <AppLoading class="loading" v-if="loading"></AppLoading>
      </div>
      <div class="desc">*部分教练不参与本次评选，实际情况以门店为主</div>
    </div>
  </div>
</template>

<script>
import AppLoading from '@/components/app/loading/loading.vue'
export default {
  components: { AppLoading },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: true,
      myCoachList: null
    }
  },
  computed: {
    activityData() {
      return this.$store.state.coachActivity2024.activityData
    },
    curStoreData() {
      return this.$store.state.coachActivity2024.coachRankData.curStoreData
    }
  },
  watch: {
    show() {
      if (this.show) {
        this.getMyCoach()
      }
    }
  },
  created() {
    this.getMyCoach()
  },
  methods: {
    test() {
      this.bindClose()
      this.$store.commit('coachActivity2024/setLotteryData', {
        reward_name: '健萌年卡',
        reward_image:
          'https://btw-common-data.betterwestar.com/btw-admin/resource/ab560bce9238f22cb29a57ae7a5eb2cd_wh=330_330.jpg',
        reward_describe: '已自动发放到账号',
        reward_type: 1
      })
      this.$store.commit('coachActivity2024/setLotteryAnimateCoachInfo', {
        coach_name: '潘子',
        coach_img:
          'https://wegymercdn.gymcity.com.cn/coach_archives_3.0/9df9af47756e8a3a2769e8b190b67f7c.png'
      })
      this.$store.commit('coachActivity2024/setLotteryAnimateToast', true)
    },
    bindClose() {
      this.$emit('close')
    },
    async bindSendFlower(item) {
      if (this.activityData.surplus_raffle_num <= 0) {
        this.$toast('你还没有小红花哦~')
        return
      }
      this.loading = true
      let res = await this.$http
        .getApp('api/v1/AnnualCoach/giveRedFlower', { coach_id: item.coach_id })
        .catch(() => {
          this.$toast('服务器开小差了，请稍后再试')
        })
      this.loading = false
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.bindClose()
          this.$store.commit('coachActivity2024/setLotteryData', res.data)
          this.$store.commit(
            'coachActivity2024/setLotteryAnimateCoachInfo',
            item
          )
          this.$store.commit('coachActivity2024/setLotteryAnimateToast', true)
          this.$store.dispatch('coachActivity2024/actionPrizeList')
          this.$store.dispatch('coachActivity2024/actionActivityIndex')
          /* 如果赠送的教练门店id = 当前选择的门店排行榜 则更新 */
          if (
            this.curStoreData &&
            item.coach_store_id == this.curStoreData.store_id
          ) {
            this.$store.dispatch(
              'coachActivity2024/actionCoachRank',
              this.curStoreData.store_id
            )
          }
          //更新门店榜
          this.$store.dispatch(
            'coachActivity2024/actionUpdateStoreRankByStoreId',
            item.coach_store_id
          )
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async getMyCoach() {
      let res = await this.$http
        .getApp('api/v1/AnnualCoach/getUserClassCoach')
        .catch(() => {})
      this.loading = false
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.myCoachList = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.send-flower {
  position: relative;
  z-index: 1;
  max-height: 664px;
  min-height: 400px;
  box-sizing: border-box;
  background: linear-gradient(178deg, #ffc0dc 0%, #fff3f8 100%);
  border-radius: 8px 8px 0px 0px;
  padding: 85px 12px 0px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  .desc {
    text-align: center;
    font-size: 12px;
    color: rgba(48, 48, 56, 0.5);
    margin-top: 13px;
    margin-bottom: 43px;
    line-height: 16px;
  }
  .loading {
    position: absolute;
    left: 50%;
    top: 30%;
    transform: translate(-50%, -50%);
  }
  .toast-bg {
    z-index: -1;
    width: 100%;
    left: 0;
    top: -26px;
    position: absolute;
  }
  .title-image {
    z-index: -1;
    width: 157px;
    left: 20px;
    top: 20px;
    position: absolute;
  }
  .tips {
    margin-bottom: 9px;
    font-weight: bold;
    font-size: 12px;
    color: rgba(48, 48, 56, 0.78);
    line-height: 18px;
  }
  .coach-scroll {
    max-height: 490px;
    min-height: 234px;
    border-radius: 8px 8px 0px 0px;
    overflow-y: scroll;
  }
  .coach-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background: #ffffff;
    border-radius: 8px 8px 0px 0px;
  }
  .coach-list {
    padding: 20px 16px;
    .coach-item {
      display: flex;
      align-items: center;
      margin-bottom: 31px;

      .avatar-container {
        position: relative;
        width: 44px;
        height: 44px;
        margin-right: 10px;
        .avatar {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          overflow: hidden;
          object-fit: cover;
        }
        .main {
          white-space: nowrap;
          padding: 0px 7px;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translate(-50%, 0%);
          height: 15px;
          box-sizing: border-box;
          background: #f64372;
          border-radius: 8px;
          border: 1px solid #ffffff;
          font-weight: bold;
          font-size: 10px;
          line-height: 13px;
          color: #ffffff;
        }
      }
      .item-center {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        .item-truename {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-weight: bold;
          font-size: 16px;
          color: #050b27;
          line-height: 22px;
          margin-bottom: 6px;
        }
        .item-store {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-size: 12px;
          color: rgba(48, 48, 56, 0.5);
          line-height: 16px;
        }
      }
      .send-flower-btn {
        margin-left: 10px;
        width: 99px;
        height: 39px;
        object-fit: contain;
      }
    }
    .coach-item:last-child {
      margin-bottom: 0;
    }
  }
  .space {
    height: 30px;
  }
  .close {
    position: absolute;
    right: 15px;
    top: 15px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    .iconfont {
      font-weight: bold;
      font-size: 20px;
      color: rgba(48, 48, 56, 1);
    }
  }
  .empty {
    width: 100%;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .empty-image {
      width: 214px;
      height: 112px;
      object-fit: contain;
      margin-bottom: 25px;
    }
    .empty-text {
      font-weight: bold;
      font-size: 16px;
      color: rgba(5, 11, 39, 0.5);
      line-height: 22px;
    }
  }
}
</style>
